import script from "./MatchLottery.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchLottery.vue?vue&type=script&setup=true&lang=js"

import "./MatchLottery.vue?vue&type=style&index=0&id=3a69e972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a69e972"]])

export default __exports__